s-input-extended {
  div[data-ref='input-wrapper'] {
    position: relative;
    width: 100%;

    button:focus {
      box-shadow: inset 0 0 0 2px var(--color-blue-dark);
    }

    button[data-ref='secondary-action-button'] {
      position: absolute;
      right: 2.625rem;
      top: 0;
    }

    button[data-ref='primary-action-button'] {
      position: absolute;
      right: 0;
      top: 0;
    }

    div[data-ref='decorative-icon-container'] {
      align-items: center;
      display: flex;
      height: 2.25rem;
      justify-content: center;
      left: 0;
      position: absolute;
      top: 0;
      width: 2.25rem;

      s-icon {
        color: var(--color-gray-medium);
      }
    }
  }

  &[type='search'] {
    input {
      padding-right: 4.875rem;
    }
  }

  &:not([type='search']) {
    input {
      padding-left: 2.25rem;
      padding-right: 2.25rem;
    }
  }

  @media (-ms-high-contrast: none), (-ms-high-contrast: active) {
    // remove close icon on Internet Explorer
    input::-ms-clear {
      display: none;
    }
  }
}
